import { FC } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { errorMessages, successMessages } from 'data/messages/messages';
import { TRtkErrorType } from 'data/types/general.types';
import Modal from 'components/Base/Modal';
import { useCreateChatMutation } from 'redux/apiSlices/chats.slice';
import { AddChatGroupSchema } from 'data/validation/ChatSchemas';
import AddChatModalForm from './AddChatModalForm';

const AddChatModal: FC<{
  open: boolean;
  closeModal: () => void;
  projectId: string;
}> = ({ open, closeModal, projectId }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [addChat, { isLoading }] = useCreateChatMutation();
  const { handleSubmit, formState, register } = useForm<{
    chatName: string;
  }>({
    defaultValues: {
      chatName: '',
    },
    resolver: yupResolver(AddChatGroupSchema),
  });

  const onClose = () => {
    closeModal();
  };

  const onSubmit: SubmitHandler<{ chatName: string }> = async values => {
    try {
      await addChat({ projectId, chatName: values.chatName }).unwrap();
      enqueueSnackbar(successMessages.toast, {
        variant: 'success',
      });
      closeModal();
    } catch (err) {
      const error = err as TRtkErrorType;
      enqueueSnackbar(error?.data?.message || errorMessages.default, {
        variant: 'error',
      });
    }
  };
  return (
    <Modal
      open={open}
      handleClose={onClose}
      title="New Chat"
      submitButtonProps={{
        disabled: formState.isSubmitting,
        loading: isLoading,
        text: 'Create',
        onClick: handleSubmit(onSubmit),
      }}
      contentProps={{ sx: { minWidth: '300px' } }}
    >
      <AddChatModalForm
        onSubmit={handleSubmit(onSubmit)}
        formState={formState}
        register={register}
      />
    </Modal>
  );
};

export default AddChatModal;
